// @ts-strict-ignore
import MapLocation from './map_location.png'
import { mapStyles } from '@lib/map-styles'
import { mapStylesDark } from '@lib/map-styles-dark'
import GoogleMapReact from 'google-map-react'
import { FC } from 'react'

type Props = {
  lat: number
  lng: number
  variant?: 'rolex' | 'rcpo'
}

const mapOptions = (maps) => ({
  fullscreenControl: false,
  zoomControl: false,
  clickableIcons: false,
  zoomControlOptions: {
    position: maps.ControlPosition.TOP_RIGHT,
  },
})

const LocationPin: FC<{ lat: number; lng: number }> = () => (
  <img src={MapLocation.src} alt="location-pin" />
)

const StoreMap: FC<Props> = ({ lat, lng, variant = 'rolex' }) => {
  return (
    <div className="relative h-[550px] w-full">
      <GoogleMapReact
        style={{ position: 'absolute', height: '100%', width: '100%' }}
        bootstrapURLKeys={{ key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY }}
        options={{ ...mapOptions, styles: variant === 'rolex' ? mapStyles : mapStylesDark }}
        yesIWantToUseGoogleMapApiInternals
        defaultCenter={{
          lat: lat,
          lng: lng,
        }}
        defaultZoom={8}
      >
        <LocationPin lat={lat} lng={lng} />
      </GoogleMapReact>
    </div>
  )
}

export default StoreMap
